import { motion } from "framer-motion";
import { ReactNode } from "react";

type SectionProps = {
  eyebrow?: string;
  title?: string;
  description?: string;
  children: ReactNode;
  className?: string;
  align?: "left" | "center";
};

export function Section({
  eyebrow,
  title,
  description,
  children,
  className = "",
  align = "center",
}: SectionProps) {
  return (
    <section className={`relative py-20 sm:py-24 ${className}`}>
      <div className="container">
        {(eyebrow || title || description) && (
          <motion.div
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className={`mb-12 max-w-3xl ${
              align === "center" ? "mx-auto text-center" : ""
            }`}
          >
            {eyebrow && <p className="eyebrow">{eyebrow}</p>}
            {title && <h2 className="section-title">{title}</h2>}
            {description && <p className="section-copy">{description}</p>}
          </motion.div>
        )}
        {children}
      </div>
    </section>
  );
}
